import { RFIOrganizations } from '../../../cimsPage/instances/rfi'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const object = 'Organization'
const page = RFIOrganizations

const rfiOrganization = CreateViewEditSoftRemoveRestore({
  page,
  object,
  create: '5B392FE2-032E-4173-A7FB-BC151A424945',
  view: 'B8ACF451-DADD-44B6-A679-C27002E07EFA',
  edit: '9983C2BD-242E-4539-A92C-A94CAD4E16D8',
  removeRestore: '3A3176D4-6D01-4D90-8D50-19346911B1AB',
})

export const CreateRFIOrganization = rfiOrganization.Create
export const ViewRFIOrganization = rfiOrganization.View
export const EditRFIOrganization = rfiOrganization.Edit
export const RemoveRestoreRFIOrganization = rfiOrganization.RemoveRestore

export type RFIOrganizationPermission =
  | typeof CreateRFIOrganization
  | typeof ViewRFIOrganization
  | typeof EditRFIOrganization
  | typeof RemoveRestoreRFIOrganization
